import React, { Component } from 'react';
import Markdown from 'react-markdown';
import CodeBlock from './CodeBlock';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import './Page.css';

class Page extends Component{
  constructor(){
    super();
    this.state = {
      markdown: ''
    }
  }

  componentWillMount(){
    const { path } = this.props;
    const filePath = require(`../Pages/${path}.md`);

    fetch(filePath).then(response => {
      return response.text()
    }).then(text => {
      this.setState({ markdown: text})
    })
  }


  render(){

    const { title } = this.props;

    return(
      <ReactCSSTransitionGroup
      className="docs-layout__content"
      transitionName="example"
      transitionAppear={true}
      transitionAppearTimeout={500}
      transitionEnter={false}
      transitionLeave={false}>
      <article className="docs-page">

        <h1>{title}</h1>

        <Markdown
          source={this.state.markdown}
          escapeHtml={false}
          renderers={{code: CodeBlock}}
        />
      </article>
      </ReactCSSTransitionGroup>
    );
  }
};

export default Page;



// WEBPACK FOOTER //
// ./src/Components/Page.js